import Vue from "vue";

import Router from "vue-router";

import store from "@/store/index";

//import LandingPage from "@/pages/LandingPage";
import PaymentMethod from "@/pages/PaymentMethod";
import PaymentDetails from "@/pages/PaymentDetails";
import PaymentCheckout from "@/pages/PaymentCheckout";
import AdHocSession from "@/pages/AdHocSession";
import EvsePicker from "@/pages/EvsePicker";
import SessionConfirm from "@/pages/SessionConfirm";

import NotFound from "@/pages/NotFoundPage";

//import WelcomeLayout from "@/layout/simpleLayout/WelcomeLayout";
//import SimpleLayout from "@/layout/simpleLayout/SimpleLayout";
import { log } from "../plugins/consoleLogger";

Vue.use(Router);


export const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    // {
    //   path: "/:countryCode/:partyId/:locationId",
    //   name: "Welcome",
    //   props: true,
    //   meta: { layout: "welcome" },
    //   component: LandingPage,
    //   beforeEnter: (to, from, next) => {
    //     log("info", to.params.countryCode)
    //     if (to.params.countryCode != "ES") {
    //       next({
    //         path: '*',
    //         replace: true
    //       })
    //     }
    //     else { return next() }
    //   },
    // },
    {
      path: "/evsePicker",
      name: "EvsePicker",
      props: true,
      meta: { layout: "simple" },
      component: EvsePicker
    },
    {
      path: "/:countryCode/:partyId/:locationId",
      name: "PaymentMethod",
      props: true,
      meta: { layout: "simple" },
      component: PaymentMethod,
      beforeEnter: (to, from, next) => {
        log("info", to.params.countryCode)
        if (to.params.countryCode != "ES") {
          next({
            path: '*',
            replace: true
          })
        }
        else { return next() }
      }
    },
    {
      path: "/payment/details",
      name: "PaymentDetails",
      props: true,
      meta: { layout: "simple" },
      component: PaymentDetails,
      // beforeEnter: (to, from, next) => {
      //   if (sessionStatus.payment === undefined) {
      //     next({
      //       path: '*',
      //       replace: true
      //     })
      //   }
      //   else { return next() }
      // },
    },
    {
      path: "/payment/checkout",
      name: "PaymentCheckout",
      props: true,
      meta: { layout: "simple" },
      component: PaymentCheckout
    },
    {
      path: "/confirm",
      name: "SessionConfirm",
      props: true,
      meta: { layout: "simple" },
      component: SessionConfirm
    },
    {
      path: "/session",
      name: "AdHocSession",
      props: true,
      meta: { layout: "simple" },
      component: AdHocSession,
      // beforeEnter: (to, from, next) => {
      //   log("info", sessionStatus.status)
      //   if (sessionStatus.status !== ("Active" || "Completed")) {
      //     next({
      //       path: '*',
      //       replace: true
      //     })
      //   }
      //   else { return next() }
      // },
    },
    {
      path: "*",
      name: "*",
      meta: { isPublic: true, group: "404", layout: "simple" },
      component: NotFound
    }
  ]
});

router.beforeEach((to, from, next) => {

  const sessionStatus = store.state.session.session;

  log("trace", `Router beforeEach
  to.path: ${to.path}
  to.name: ${to.name}
  session status: ${sessionStatus.status}
  session location: ${JSON.stringify(sessionStatus.location)}`);
  
  if(to.name === "PaymentMethod"){
    const location = to.path.split('/');
    location.shift();

    log("trace", `Adjusted location path: ${location[0]}/${location[1]}/${location[2]}`)
    
    if(
      location[0] !== sessionStatus.location.countryCode ||
      location[1] !== sessionStatus.location.partyId ||
      location[2] !== sessionStatus.location.locationId
    ){
      if(
        sessionStatus.status === undefined ||
        sessionStatus.status === "Created" ||
        sessionStatus.status === "Completed"
      ){
        store.commit("session/clear")
        next();
      } else if (
        sessionStatus.status === "Authorized" ||
        sessionStatus.status === "Pending"
      ) {
        //TODO: cancel payment auth
        store.dispatch("session/cancelPayment", store.state.session.session.paymentId)
        store.commit("session/clear")
        next();
      }
    }
  }

  switch(sessionStatus.status){
    case "Created":
      if(from.name === null && to.name === "PaymentCheckout") {
        next();
      } else if (to.name === "PaymentMethod" || to.name === "PaymentDetails") {
        next();
      } else {
        next({
          name: "PaymentDetails"
        });
      }
      break;
    case "Authorized":
      if (to.name === "PaymentMethod") {
        next();
      } else {  
        next({
          name: "PaymentCheckout",
          query: {
            id: sessionStatus.paymentId
          }
        });
      }
      break;
    case "Pending":
      if (to.name === "PaymentMethod") {
        next();
      } else if(to.name === "EvsePicker"){
        next();
      } else if(to.name === "SessionConfirm"){
        next();
      } else if(to.name === "AdHocSession"){
        next();
      } else {
        next({
          name: "EvsePicker"
        });
      }
      break;
    case "Active":
    case "Completed":
      if (to.name === "AdHocSession") {
        next();
      } else {
        next({
          name: "AdHocSession"
        });
      }
      break;
    default:
      next();
      break;
  }
});